import React, { useEffect } from 'react';

const isMajorHeading = (line, index) => index > 1 && /^(\d+[\).]\s|Overview$)/.test(line.trim());
const isSubHeading = (line) => /^\d+\.\d+\s/.test(line.trim());

const LegalDocument = ({ lines }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const title = lines[0] || '';
    const lastUpdated = lines[1] || '';
    const bodyLines = lines.slice(2);

    const styles = {
        container: {
            maxWidth: '1000px',
            margin: '0 auto',
            padding: '120px 24px 60px',
            color: '#414141',
            fontFamily: 'Mulish, sans-serif',
        },
        header: {
            marginBottom: '40px',
            borderBottom: '1px solid #E5E7EB',
            paddingBottom: '20px',
        },
        h1: {
            fontSize: '36px',
            fontWeight: '800',
            color: '#2B2B2B',
            marginBottom: '10px',
        },
        lastUpdated: {
            color: '#6E6E6E',
            fontSize: '14px',
            whiteSpace: 'pre-wrap',
        },
        p: {
            margin: '0 0 16px',
            lineHeight: '1.7',
            fontSize: '16px',
            whiteSpace: 'pre-wrap',
        },
        spacer: {
            height: '12px',
        },
        h2: {
            display: 'block',
            fontSize: '24px',
            fontWeight: '700',
            color: '#D81F26',
            margin: '32px 0 16px',
            lineHeight: '1.35',
            whiteSpace: 'pre-wrap',
        },
        h3: {
            display: 'block',
            fontSize: '18px',
            fontWeight: '700',
            color: '#3457D5',
            margin: '24px 0 12px',
            lineHeight: '1.45',
            whiteSpace: 'pre-wrap',
        },
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h1 style={styles.h1}>{title}</h1>
                <div style={styles.lastUpdated}>{lastUpdated}</div>
            </div>

            {bodyLines.map((line, index) => {
                const key = `${index}-${line.slice(0, 20)}`;
                if (!line) {
                    return <div key={key} style={styles.spacer} />;
                }
                if (isMajorHeading(line, index + 2)) {
                    return <p key={key} style={styles.h2}>{line}</p>;
                }
                if (isSubHeading(line)) {
                    return <p key={key} style={styles.h3}>{line}</p>;
                }
                return <p key={key} style={styles.p}>{line}</p>;
            })}
        </div>
    );
};

export default LegalDocument;
